import React from 'react';
import { useIntl } from 'react-intl';
import './color-picker.scss';
export const ColorPicker = ({ value, onChange, placeholder, required, }) => {
    const intl = useIntl();
    const formatMessage = intl.formatMessage.bind(intl);
    const handleChange = (e) => {
        onChange(e.target.value);
    };
    return (<div className="color-picker-wrapper">
      <input type="text" className="form-control" value={value} onChange={handleChange} placeholder={placeholder ?? formatMessage({ id: 'common.enter-value' })} maxLength={7} required={required}/>
      <input type="color" className="color-picker-input" value={value || '#000000'} onChange={handleChange}/>
    </div>);
};
